module.exports = __webpack_public_path__ + "img/mh_cableman.bcbeaea4.svg";